import type { UseUserProps } from '@ztechapps/common.hook'
import { useUser as useUserCore } from '@ztechapps/common.hook'
import { appSettings } from '../config/app-settings'

export const useUser = (
  {
    userIdKey = appSettings.userStorageKeys.userId,
    tokenKey = appSettings.userStorageKeys.token,
    ...props
  } = {} as UseUserProps
) => {
  return useUserCore({
    userIdKey,
    tokenKey,
    ...props,
  })
}
